<footer>
  <div class="container">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-md-6 footer-column">
            <dl>
              <dt>Kik vagyunk?</dt>
              <dd><a [routerLink]="['/rolunk']">Rólunk</a></dd>
              <dd><a [routerLink]="['/kapcsolat']">Kapcsolat</a></dd>
              <dd><a [routerLink]="['/komment']">Üzenj nekünk!</a></dd>
              <dd><a [routerLink]="['/barataink']">Barátaink</a></dd>
            </dl>
            <dl>
              <dt>Tartalmak</dt>
              <dd><a [routerLink]="['/hirek']">Hírek</a></dd>
              <!--<dd><a [routerLink]="['/naptar']">Naptár</a></dd>-->
            </dl>
          </div>
          <div class="col-md-6 footer-column">
            <dl>
              <dt>Programok</dt>
              <dd><a [routerLink]="['/istentiszteletek']">Istentiszteletek</a></dd>
              <dd><a [routerLink]="['/gyerekfogi']">Gyermekfoglalkozások</a></dd>
              <dd><a [routerLink]="['/ifi']">Ifjúsági alkalmak</a></dd>
              <dd><a [routerLink]="['/hazasrandi']">Házasoknak</a></dd>
              <dd><a [routerLink]="['/hazicsoportok']">Házicsoportok</a></dd>
              <dd><a [routerLink]="['/taborok']">Táborok, konferenciák</a></dd>
              <dd><a [routerLink]="['/bibliaiskola']">Bibliaiskola</a></dd>
            </dl>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-md-6 footer-column">
            <dl>
              <dt>Felvételek</dt>
              <dd><a [routerLink]="['/tanitasok']">Tanítások</a></dd>
              <dd><a [routerLink]="['/sorozatok']">Sorozatok</a></dd>
            </dl>
            <dl>
              <dt>Missziók</dt>
              <dd><a [routerLink]="['/bab']">Báb csapat</a></dd>
              <dd><a [routerLink]="['/pantomim']">Pantomim</a></dd>
              <dd><a [routerLink]="['/plantalt']">Plántált gyülekezeteink</a></dd>
              <dd><a [routerLink]="['/misszionariusok']">Misszionáriusaink</a></dd>
            </dl>
          </div>
          <div class="col-md-6 footer-column">
            <dl>
              <dt>Elérhetőségeink</dt>
              <dd class="no-upper"><i class="fa fa-envelope-o"></i> kapkerkoz (kukac) gmail.com</dd>
              <dd class="no-upper"><i class="fa fa-map-marker"></i> 7400&nbsp;Kaposvár, Kanizsai&nbsp;u.&nbsp;56.<br />(Roberto csempeáruház mellett)</dd>
              <dd class="no-upper"><i class="fa fa-phone"></i> +36 70 701 7834</dd>
            </dl>
            <div class="logo">
              <img src="/assets/logo-white-wide-2.png" alt="logo" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center copy">
        <small>Kaposvári Keresztény Közösség &copy; 1997-2017</small>
      </div>
      <div class="col-12 text-center creator">
        Az oldalt készítette és karban tartja: <a href="https://doxasoft.hu" target="_blank">Doxa Soft</a>
      </div>
    </div>
  </div>
</footer>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/footer/footer.component.html